"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeAddressParams = void 0;
const errors_1 = require("../../errors");
const invalidDataReason_1 = require("../../errors/invalidDataReason");
const internal_1 = require("../../types/internal");
const utils_1 = require("../../utils");
const assert_1 = require("../../utils/assert");
const serialize_1 = require("../../utils/serialize");
const getVersion_1 = require("../getVersion");
function serializeSpendingDataSource(dataSource) {
    switch (dataSource.type) {
        case "spending_path":
            return (0, serialize_1.path_to_buf)(dataSource.path);
        case "spending_script_hash":
            return (0, serialize_1.hex_to_buf)(dataSource.scriptHashHex);
        case "no_spending":
            return Buffer.alloc(0);
        default:
            (0, assert_1.unreachable)(dataSource);
    }
}
function serializeStakingDataSource(dataSource) {
    const stakingChoicesEncoding = {
        ["no_staking"]: 0x11,
        ["staking_key_path"]: 0x22,
        ["staking_key_hash"]: 0x33,
        ["blockchain_pointer"]: 0x44,
        ["staking_script_hash"]: 0x55,
    };
    switch (dataSource.type) {
        case "no_staking": {
            return Buffer.concat([
                (0, serialize_1.uint8_to_buf)(stakingChoicesEncoding[dataSource.type]),
            ]);
        }
        case "staking_key_hash": {
            return Buffer.concat([
                (0, serialize_1.uint8_to_buf)(stakingChoicesEncoding[dataSource.type]),
                (0, serialize_1.hex_to_buf)(dataSource.keyHashHex),
            ]);
        }
        case "staking_script_hash": {
            return Buffer.concat([
                (0, serialize_1.uint8_to_buf)(stakingChoicesEncoding[dataSource.type]),
                (0, serialize_1.hex_to_buf)(dataSource.scriptHashHex),
            ]);
        }
        case "staking_key_path": {
            return Buffer.concat([
                (0, serialize_1.uint8_to_buf)(stakingChoicesEncoding[dataSource.type]),
                (0, serialize_1.path_to_buf)(dataSource.path),
            ]);
        }
        case "blockchain_pointer": {
            return Buffer.concat([
                (0, serialize_1.uint8_to_buf)(stakingChoicesEncoding[dataSource.type]),
                (0, serialize_1.uint32_to_buf)(dataSource.pointer.blockIndex),
                (0, serialize_1.uint32_to_buf)(dataSource.pointer.txIndex),
                (0, serialize_1.uint32_to_buf)(dataSource.pointer.certificateIndex),
            ]);
        }
        default:
            (0, assert_1.unreachable)(dataSource);
    }
}
function serializeAddressParams(params, version) {
    let spending = params.spendingDataSource;
    let staking = params.stakingDataSource;
    if (!(0, getVersion_1.getCompatibility)(version).supportsMultisigTransaction) {
        if (params.type === internal_1.AddressType.REWARD_KEY) {
            (0, assert_1.assert)(staking.type === "staking_key_path", invalidDataReason_1.InvalidDataReason.ADDRESS_INVALID_STAKING_INFO);
            spending = {
                type: "spending_path",
                path: staking.path,
            };
            staking = {
                type: "no_staking",
            };
        }
        else if (params.type === internal_1.AddressType.REWARD_SCRIPT) {
            throw new errors_1.DeviceVersionUnsupported(`Scripthash based address derivation not supported by Ledger app version ${(0, utils_1.getVersionString)(version)}.`);
        }
    }
    return Buffer.concat([
        (0, serialize_1.uint8_to_buf)(params.type),
        params.type === internal_1.AddressType.BYRON
            ? (0, serialize_1.uint32_to_buf)(params.protocolMagic)
            : (0, serialize_1.uint8_to_buf)(params.networkId),
        serializeSpendingDataSource(spending),
        serializeStakingDataSource(staking),
    ]);
}
exports.serializeAddressParams = serializeAddressParams;
//# sourceMappingURL=data:application/json;base64,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